import React, { useCallback, useMemo, useState } from 'react'
import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import VesselLandingContext from '../context/VesselLandingContext'
import VesselLandingModal from '../../modules/Management/components/VesselLanding'

type Props = {
  children: React.ReactNode
}

const VesselLandingProvider: React.FC<Props> = ({ children }) => {
  const [activeVesselId, setActiveVesselId] = useState<number | null>(null)

  const openVesselLanding = useCallback((vesselId: number) => {
    if (!Number.isFinite(Number(vesselId))) return
    setActiveVesselId(Number(vesselId))
  }, [])

  const closeVesselLanding = useCallback(() => {
    setActiveVesselId(null)
  }, [])

  useEffect(() => {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<{ vesselId?: number | string }>
      const vesselId = Number(customEvent.detail?.vesselId)
      if (!Number.isFinite(vesselId)) return
      setActiveVesselId(vesselId)
    }

    window.addEventListener('open-vessel-landing', handler as EventListener)
    return () => window.removeEventListener('open-vessel-landing', handler as EventListener)
  }, [])

  const contextValue = useMemo(
    () => ({
      openVesselLanding,
      closeVesselLanding,
      activeVesselId,
    }),
    [activeVesselId, closeVesselLanding, openVesselLanding]
  )

  return (
    <VesselLandingContext.Provider value={contextValue}>
      {children}
      {activeVesselId != null && typeof document !== 'undefined'
        ? createPortal(
          <VesselLandingModal
            isOpen={true}
            vesselId={activeVesselId}
            onClose={closeVesselLanding}
          />,
          document.body
        )
        : null}
    </VesselLandingContext.Provider>
  )
}

export default VesselLandingProvider
